<template>
  <div class="yioks-privacy-text">
    <div class="privacy-value">{{ displayText }}</div>
    <v-icon
      v-if="showToggle && value"
      class="privacy-eye"
      :name="visible ? 'eye-slash' : 'eye'"
      :scale="iconScale"
      @click.native="toggle"
    ></v-icon>
  </div>
</template>

<script>
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/eye-slash'
import { filterPhone, filterIdNumberPrivacy } from '@/utils/yioks_filter'

export default {
  name: 'YioksPrivacyText',
  props: {
    // 需要展示的原始值（手机号 / 身份证号）
    value: {
      type: [String, Number],
      default: ''
    },
    // 隐私类型：phone 手机号；idNumber 身份证号
    type: {
      type: String,
      default: 'phone'
    },
    // 是否显示小眼睛切换按钮
    showToggle: {
      type: Boolean,
      default: true
    },
    // 眼睛图标大小
    iconScale: {
      type: [Number, String],
      default: 1
    },
    // 默认是否明文展示
    defaultVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: this.defaultVisible
    }
  },
  computed: {
    displayText () {
      const val = this.value
      if (!val) return '--'
      if (this.visible) return String(val)
      return this.type === 'idNumber' ? filterIdNumberPrivacy(val) : filterPhone(val)
    }
  },
  methods: {
    toggle () {
      this.visible = !this.visible
      this.$emit('change', this.visible)
    }
  }
}
</script>

<style lang="stylus" scoped>
.yioks-privacy-text
  display inline-flex
  align-items center
  .privacy-eye
    margin-left .08rem
    cursor pointer
    &:hover
      color #409EFF
</style>
